export const PERMISSIONS_VERSION = 1

export const PERMISSIONS = {
  // User & access management
  manage_users:        ['admin', 'superadmin'],
  manage_modules:      ['superadmin'],
  view_modules:        ['admin', 'superadmin'],
  delete_anything:     ['superadmin'],

  // Content
  manage_files:        ['admin', 'superadmin'],
  manage_events:       ['admin', 'superadmin'],
  manage_polls:        ['admin', 'superadmin'],
  manage_badges:       ['admin', 'superadmin'],
  manage_albums:       ['admin', 'superadmin'],
  manage_nas:          ['admin', 'superadmin'],

  // Game & tournament
  manage_game_servers: ['admin', 'superadmin'],
  manage_tournaments:  ['admin', 'superadmin'],
  referee_access:      ['admin', 'superadmin', 'referee'],

  // Communication
  manage_chat:         ['admin', 'superadmin'],
  manage_spotify:      ['admin', 'superadmin'],
  manage_teamspeak:    ['admin', 'superadmin'],

  // Helpdesk
  helpdesk_access:     ['admin', 'superadmin', 'helpdesk'],
  delete_tickets:      ['admin', 'superadmin'],

  // Infrastructure & settings
  manage_points:       ['admin', 'superadmin'],
  manage_clan:         ['admin', 'superadmin'],
  manage_clan_mutate:  ['superadmin'],
  manage_pterodactyl:  ['admin', 'superadmin'],
  manage_seats:        ['admin', 'superadmin'],
  manage_settings:     ['admin', 'superadmin'],
  view_stats:          ['admin', 'superadmin', 'referee'],
};

export const can = (role, permission) => PERMISSIONS[permission]?.includes(role) ?? false;
